import { EnderecoFieldGroupModel, simNaoEnumToBoolean } from 'components/form'
import { isEnderecoNaoPreenchido } from 'components/form/field/endereco/endereco-utils'
import { getLotacaoResponsavel } from 'components/lotacao-responsavel/utils/utils-lotacaoResponsavel'
import {
  Cbo,
  CidadaoFciInput,
  CondicoesSaudeAutorreferidasInput,
  EnderecoInput,
  Escolaridade,
  InformacoesSociodemograficas,
  InformacoesSociodemograficasInput,
  InformacoesSocioEconomicas,
  InformacoesSocioEconomicasInput,
  Pais,
  SituacaoDeRua,
  SituacaoDeRuaInput,
} from 'graphql/types.generated'
import { tipoSanguineo } from 'types/enums'
import { booleanToSimNaoEnum } from 'view/cadastro-imovel/utils-cadastroImovel'

import {
  CidadaoFci,
  CidadaoFciFormModel,
  CondicoesSaudeAutorreferidasFormModel,
  escolaridadeRecord,
  estadoCivilRecord,
  InformacoesSociodemograficasFormModel,
  InformacoesSocioEconomicasFormModel,
  PAIS_BRASIL,
  SituacaoRuaFormModel,
} from './model-cidadaoFci'

export function convertToCidadaoFciInput(model: CidadaoFciFormModel): CidadaoFciInput {
  const {
    dadosPessoais,
    contatos,
    endereco,
    informacoesSocioEconomicas,
    informacoesSociodemograficas,
    condicoesSaudeAutorreferidas,
    responsabilidadeAcompanhamento,
    desativarCompartilhamentoProntuario,
  } = model

  return {
    id: model.id,
    nome: dadosPessoais.nome,
    nomeSocial: dadosPessoais.nomeSocial,
    sexo: dadosPessoais.sexo,
    dataNascimento: dadosPessoais.dataNascimento,
    cpf: dadosPessoais.cpf,
    cns: dadosPessoais.cns,
    nisPisPasep: dadosPessoais.nisPisPasep,
    racaCor: dadosPessoais.racaCor.value,
    etniaId: dadosPessoais.etnia?.id,
    tipoSanguineo: dadosPessoais.tipoSanguineo?.identificador,
    estadoCivil: estadoCivilRecord[dadosPessoais.estadoCivil?.id],
    nacionalidade: dadosPessoais.nacionalidadeCidadao.nacionalidade,
    municipioNascimento: dadosPessoais.nacionalidadeCidadao.municipioNascimento?.id,
    dataEntradaPais: dadosPessoais.nacionalidadeCidadao.dataEntradaPais,
    paisNascimento: dadosPessoais.nacionalidadeCidadao.paisNascimento?.id,
    dataNaturalizacao: dadosPessoais.nacionalidadeCidadao.dataNaturalizacao,
    portariaNaturalizacao: dadosPessoais.nacionalidadeCidadao.portariaNaturalizacao,
    nomePai: dadosPessoais.nomePai,
    nomeMae: dadosPessoais.nomeMae,
    desconheceNomePai: dadosPessoais.desconheceNomePai,
    desconheceNomeMae: dadosPessoais.desconheceNomeMae,
    desejaInformarOrientacaoSexual: simNaoEnumToBoolean[dadosPessoais.desejaInformarOrientacaoSexual],
    identidadeGenero: dadosPessoais.identidadeGenero,
    desejaInformarIdentidadeGenero: simNaoEnumToBoolean[dadosPessoais.desejaInformarIdentidadeGenero],
    orientacaoSexual: dadosPessoais.orientacaoSexual,
    vinculacaoCidadaoTerritorio: {
      cbo2002: responsabilidadeAcompanhamento.responsavel.lotacao.cbo.cbo2002,
      cnes: responsabilidadeAcompanhamento.responsavel.lotacao.unidadeSaude.cnes,
      cns: responsabilidadeAcompanhamento.responsavel.lotacao.profissional.cns,
      ine: responsabilidadeAcompanhamento.responsavel.lotacao.equipe?.ine,
      saidaTerritorio: responsabilidadeAcompanhamento.statusCidadaoSaiuTerritorio,
      foraDeArea: responsabilidadeAcompanhamento.statusForaArea,
      microarea: responsabilidadeAcompanhamento.microarea,
    },
    // TODO(@NP): Hardcoded
    vinculacaoCidadaoFamilia: {
      isResponsavelFamiliar: true,
      cpfCnsResponsavelFamiliar: null,
      grauParentescoResponsavelFamiliar: null,
    },
    faleceu: dadosPessoais.faleceu,
    dataObito: dadosPessoais.dataObito,
    numeroDeclaracaoObito: dadosPessoais.numeroDeclaracaoObito,
    telefoneCelular: contatos.telefoneCelular,
    telefoneResidencial: contatos.telefoneResidencial,
    telefoneContato: contatos.telefoneContato,
    email: contatos.email,
    endereco: convertEnderecoToInput(endereco),
    municipioResidenciaExterior: endereco.municipioResidenciaExterior,
    paisResidenciaId: endereco.pais?.id,
    informacoesSocioEconomicas: convertInformacoesSocioEconomicasToInput(informacoesSocioEconomicas),
    informacoesSociodemograficas: convertInformacoesSociodemograficasToInput(informacoesSociodemograficas),
    condicoesSaudeAutorreferidas: convertCondicoesSaudeAutorreferidasToInput(condicoesSaudeAutorreferidas),
    stCompartilhaProntuario: !desativarCompartilhamentoProntuario,
    stSituacaoDeRua: simNaoEnumToBoolean[model.statusSituacaoRua],
    situacaoDeRua: convertSituacaoFormModelToInput(model.situacaoRua),
  }
}

export function convertToCidadaoFciFormModel(cidadao: CidadaoFci): CidadaoFciFormModel {
  return {
    id: cidadao.id,
    dadosPessoais: {
      nome: cidadao.nome,
      nomeSocial: cidadao?.nomeSocial,
      sexo: cidadao.sexo,
      dataNascimento: cidadao.dataNascimento,
      racaCor: {
        id: cidadao.racaCor.id,
        nome: cidadao.racaCor.nome,
        value: cidadao.racaCor.racaCorDbEnum,
      },
      etnia: cidadao?.etnia,
      tipoSanguineo: {
        identificador: cidadao?.tipoSanguineo,
        nome: tipoSanguineo[cidadao?.tipoSanguineo],
      },
      cpf: cidadao?.cpf,
      cns: cidadao?.cns,
      nisPisPasep: cidadao?.nisPisPasep,
      nomeMae: cidadao?.nomeMae,
      nomePai: cidadao?.nomePai,
      desconheceNomeMae: cidadao?.desconheceNomeMae,
      desconheceNomePai: cidadao?.desconheceNomePai,
      desejaInformarIdentidadeGenero: booleanToSimNaoEnum(cidadao?.desejaInformarIdentidadeGenero),
      identidadeGenero: cidadao?.identidadeGeneroDbEnum,
      desejaInformarOrientacaoSexual: booleanToSimNaoEnum(cidadao?.desejaInformarOrientacaoSexual),
      orientacaoSexual: cidadao?.orientacaoSexualDbEnum,
      estadoCivil: cidadao?.estadoCivil,
      nacionalidadeCidadao: {
        nacionalidade: cidadao.nacionalidade.nacionalidadeDbEnum,
        municipioNascimento: {
          id: cidadao?.localidadeNascimento?.id,
          nome: cidadao?.localidadeNascimento?.nome,
          uf: cidadao?.localidadeNascimento?.uf,
          ibge: cidadao?.localidadeNascimento?.ibge,
        },
        dataEntradaPais: cidadao?.dataEntradaBrasil,
        paisNascimento: {
          id: cidadao?.paisNascimento?.id,
          nome: cidadao?.paisNascimento?.nome,
        },
        dataNaturalizacao: cidadao?.dataNaturalizacao,
        portariaNaturalizacao: cidadao?.portariaNaturalizacao,
      },
      faleceu: cidadao?.faleceu,
      dataObito: cidadao?.dataObito,
      numeroDeclaracaoObito: cidadao?.numeroDocumentoObito,
    },
    contatos: {
      telefoneResidencial: cidadao?.telefoneResidencial,
      telefoneCelular: cidadao?.telefoneCelular,
      telefoneContato: cidadao?.telefoneContato,
      email: cidadao?.email,
    },
    endereco: convertEnderecoToFormModel(cidadao?.endereco, cidadao?.localidadeExterior, cidadao?.paisExterior),
    informacoesSocioEconomicas: convertInformacoesSocioEconomicasToFormModel(cidadao?.informacoesSocioEconomicas),
    informacoesSociodemograficas: convertInformacoesSociodemograficasToFormModel(
      cidadao?.informacoesSociodemograficas,
      cidadao?.cbo,
      cidadao?.escolaridade
    ),
    condicoesSaudeAutorreferidas:
      cidadao?.condicoesSaudeAutorreferidas &&
      convertCondicoesSaudeAutorreferidasToFormModel(cidadao?.condicoesSaudeAutorreferidas),
    desativarCompartilhamentoProntuario: !cidadao?.stCompartilhaProntuario,
    statusSituacaoRua: booleanToSimNaoEnum(cidadao?.situacaoDeRua?.stSituacaoDeRua),
    situacaoRua: convertToSituacaoRuaFormModel(cidadao?.situacaoDeRua),
    responsabilidadeAcompanhamento: {
      statusCidadaoSaiuTerritorio: cidadao?.cidadaoNucleoFamiliar?.saidaTerritorio,
      microarea: cidadao?.microArea,
      statusForaArea: cidadao?.statusForaArea,
      responsavel: getLotacaoResponsavel(
        cidadao?.cidadaoNucleoFamiliar?.profissional,
        cidadao?.cidadaoNucleoFamiliar?.cbo,
        cidadao?.cidadaoNucleoFamiliar?.equipe,
        cidadao?.cidadaoNucleoFamiliar?.unidadeSaude
      ),
    },
  }
}

export const convertInformacoesSocioEconomicasToInput = (
  form: InformacoesSocioEconomicasFormModel
): InformacoesSocioEconomicasInput => {
  const hasInformacoesSocioEconomicas =
    !!form?.alimentosAcabaramAntesTerDinheiroComprarMais || !!form?.comeuAlgunsAlimentosDinheiroAcabou

  return hasInformacoesSocioEconomicas
    ? {
        statusAlimentosAcabaramAntesTerDinheiroComprarMais:
          simNaoEnumToBoolean[form.alimentosAcabaramAntesTerDinheiroComprarMais],
        statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou: simNaoEnumToBoolean[form.comeuAlgunsAlimentosDinheiroAcabou],
      }
    : null
}

export const convertInformacoesSocioEconomicasToFormModel = (
  informacoesSocioEconomicas: InformacoesSocioEconomicas
): InformacoesSocioEconomicasFormModel => {
  return (
    informacoesSocioEconomicas && {
      alimentosAcabaramAntesTerDinheiroComprarMais: booleanToSimNaoEnum(
        informacoesSocioEconomicas?.statusAlimentosAcabaramAntesTerDinheiroComprarMais
      ),
      comeuAlgunsAlimentosDinheiroAcabou: booleanToSimNaoEnum(
        informacoesSocioEconomicas?.statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou
      ),
    }
  )
}

export const convertInformacoesSociodemograficasToInput = (
  form: InformacoesSociodemograficasFormModel
): InformacoesSociodemograficasInput => {
  return (
    form && {
      escolaridade: escolaridadeRecord[form?.escolaridade?.id],
      frequentaEscolaOuCreche: simNaoEnumToBoolean[form?.frequentaEscolaOuCreche],
      criancas0a9anosComQuemFica: form?.criancas0a9anosComQuemFica,
      situacaoMercadoTrabalho: form?.situacaoMercadoTrabalho,
      ocupacaoCbo2002: form?.ocupacao?.cbo2002,
      possuiPlanoSaudePrivado: simNaoEnumToBoolean[form?.possuiPlanoSaudePrivado],
      frequentaCuidadorTradicional: simNaoEnumToBoolean[form?.frequentaCuidadorTradicional],
      participaAlgumGrupoComunitario: simNaoEnumToBoolean[form?.participaAlgumGrupoComunitario],
      isMembroComunidadeTradicional: simNaoEnumToBoolean[form?.isMembroComunidadeTradicional],
      povoComunidadeTradicional: form?.povoComunidadeTradicional,
      possuiDeficiencia: simNaoEnumToBoolean[form?.possuiDeficiencia],
      deficiencias: form?.deficiencias,
    }
  )
}

export const convertInformacoesSociodemograficasToFormModel = (
  informacoesSociodemograficas: InformacoesSociodemograficas,
  ocupacao: Cbo,
  escolaridade: Escolaridade
): InformacoesSociodemograficasFormModel => {
  return (
    (informacoesSociodemograficas || ocupacao || escolaridade) && {
      escolaridade: escolaridade,
      frequentaEscolaOuCreche: booleanToSimNaoEnum(informacoesSociodemograficas?.frequentaEscolaOuCreche),
      criancas0a9anosComQuemFica: informacoesSociodemograficas?.criancas0a9anosComQuemFica,
      situacaoMercadoTrabalho: informacoesSociodemograficas?.situacaoMercadoTrabalho,
      ocupacao: ocupacao,
      possuiPlanoSaudePrivado: booleanToSimNaoEnum(informacoesSociodemograficas?.possuiPlanoSaudePrivado),
      frequentaCuidadorTradicional: booleanToSimNaoEnum(informacoesSociodemograficas?.frequentaCuidadorTradicional),
      participaAlgumGrupoComunitario: booleanToSimNaoEnum(informacoesSociodemograficas?.participaAlgumGrupoComunitario),
      isMembroComunidadeTradicional: booleanToSimNaoEnum(informacoesSociodemograficas?.isMembroComunidadeTradicional),
      povoComunidadeTradicional: informacoesSociodemograficas?.povoComunidadeTradicional,
      possuiDeficiencia: booleanToSimNaoEnum(informacoesSociodemograficas?.possuiDeficiencia),
      deficiencias: informacoesSociodemograficas?.deficiencias,
    }
  )
}

export const convertCondicoesSaudeAutorreferidasToInput = (
  form: CondicoesSaudeAutorreferidasFormModel
): CondicoesSaudeAutorreferidasInput => {
  return (
    form && {
      stGestante: simNaoEnumToBoolean[form.stGestante],
      maternidadeReferencia: form.maternidadeReferencia,
      autodenominacaoPeso: form.autodenominacaoPeso,
      stAcamado: simNaoEnumToBoolean[form.stAcamado],
      stDomiciliar: simNaoEnumToBoolean[form.stDomiciliar],
      stFumante: simNaoEnumToBoolean[form.stFumante],
      stUsoAlcool: simNaoEnumToBoolean[form.stUsoAlcool],
      stUsoOutrasDrogas: simNaoEnumToBoolean[form.stUsoOutrasDrogas],
      stPraticasComplementares: simNaoEnumToBoolean[form.stPraticasComplementares],
      stProblemaSaudeMental: simNaoEnumToBoolean[form.stProblemaSaudeMental],
      stHipertensaoArterial: simNaoEnumToBoolean[form.stHipertensaoArterial],
      stDiabetes: simNaoEnumToBoolean[form.stDiabetes],
      stCancer: simNaoEnumToBoolean[form.stCancer],
      stDerrame: simNaoEnumToBoolean[form.stDerrame],
      stInfarto: simNaoEnumToBoolean[form.stInfarto],
      stHanseniase: simNaoEnumToBoolean[form.stHanseniase],
      stTuberculose: simNaoEnumToBoolean[form.stTuberculose],
      stDoencaCardiaca: simNaoEnumToBoolean[form.stDoencaCardiaca],
      doencaCardiaca: form.doencaCardiaca?.isNotEmpty() ? form.doencaCardiaca : null,
      stProblemaRins: simNaoEnumToBoolean[form.stProblemaRins],
      doencaRins: form.doencaRins?.isNotEmpty() ? form.doencaRins : null,
      stDoencaRespiratoria: simNaoEnumToBoolean[form.stDoencaRespiratoria],
      doencasRespiratorias: form.doencasRespiratorias?.isNotEmpty() ? form.doencasRespiratorias : null,
      stInternacaoUltimos12Meses: simNaoEnumToBoolean[form.stInternacaoUltimos12Meses],
      causaInternacaoUltimos12Meses: form.causaInternacaoUltimos12Meses,
      stPlantasMedicinais: simNaoEnumToBoolean[form.stPlantasMedicinais],
      plantasMedicinais: form.plantasMedicinais,
      condicaoSaude1: form.condicaoSaude1,
      condicaoSaude2: form.condicaoSaude2,
      condicaoSaude3: form.condicaoSaude3,
    }
  )
}

export const convertCondicoesSaudeAutorreferidasToFormModel = (
  input: CondicoesSaudeAutorreferidasInput
): CondicoesSaudeAutorreferidasFormModel => ({
  openedAccordion: [],
  stGestante: booleanToSimNaoEnum(input.stGestante),
  maternidadeReferencia: input.maternidadeReferencia,
  autodenominacaoPeso: input.autodenominacaoPeso,
  stAcamado: booleanToSimNaoEnum(input.stAcamado),
  stDomiciliar: booleanToSimNaoEnum(input.stDomiciliar),
  stFumante: booleanToSimNaoEnum(input.stFumante),
  stUsoAlcool: booleanToSimNaoEnum(input.stUsoAlcool),
  stUsoOutrasDrogas: booleanToSimNaoEnum(input.stUsoOutrasDrogas),
  stPraticasComplementares: booleanToSimNaoEnum(input.stPraticasComplementares),
  stProblemaSaudeMental: booleanToSimNaoEnum(input.stProblemaSaudeMental),
  stHipertensaoArterial: booleanToSimNaoEnum(input.stHipertensaoArterial),
  stDiabetes: booleanToSimNaoEnum(input.stDiabetes),
  stCancer: booleanToSimNaoEnum(input.stCancer),
  stDerrame: booleanToSimNaoEnum(input.stDerrame),
  stInfarto: booleanToSimNaoEnum(input.stInfarto),
  stHanseniase: booleanToSimNaoEnum(input.stHanseniase),
  stTuberculose: booleanToSimNaoEnum(input.stTuberculose),
  stDoencaCardiaca: booleanToSimNaoEnum(input.stDoencaCardiaca),
  doencaCardiaca: input.doencaCardiaca,
  stProblemaRins: booleanToSimNaoEnum(input.stProblemaRins),
  doencaRins: input.doencaRins,
  stDoencaRespiratoria: booleanToSimNaoEnum(input.stDoencaRespiratoria),
  doencasRespiratorias: input.doencasRespiratorias,
  stInternacaoUltimos12Meses: booleanToSimNaoEnum(input.stInternacaoUltimos12Meses),
  causaInternacaoUltimos12Meses: input.causaInternacaoUltimos12Meses,
  stPlantasMedicinais: booleanToSimNaoEnum(input.stPlantasMedicinais),
  plantasMedicinais: input.plantasMedicinais,
  condicaoSaude1: input.condicaoSaude1,
  condicaoSaude2: input.condicaoSaude2,
  condicaoSaude3: input.condicaoSaude3,
})

export const convertEnderecoToInput = (endereco: EnderecoFieldGroupModel): EnderecoInput =>
  isEnderecoNaoPreenchido(endereco)
    ? null
    : {
        bairro: endereco?.bairro?.nome,
        cep: endereco?.cep,
        complemento: endereco?.complemento,
        logradouro: endereco?.logradouro?.nome,
        municipio: endereco?.municipio?.id,
        numero: endereco?.numero,
        pontoReferencia: endereco?.pontoReferencia,
        semNumero: endereco?.semNumero,
        tipoLogradouro: endereco?.tipoLogradouro?.id,
        uf: endereco?.uf?.id,
      }

export const convertEnderecoToFormModel = (
  endereco: CidadaoFci['endereco'],
  localidadeExterior: string,
  paisExterior: Pais
): EnderecoFieldGroupModel => ({
  ...endereco,
  bairro: endereco?.bairro ? { nome: endereco?.bairro } : undefined,
  logradouro: endereco?.logradouro ? { nome: endereco?.logradouro } : undefined,
  municipio: endereco?.municipio && { ...endereco.municipio, uf: { ...endereco.uf } },
  tipoLogradouro: endereco?.tipoLogradouro && { ...endereco.tipoLogradouro, numeroDne: undefined },
  uf: endereco?.uf && { ...endereco.uf },
  pais: {
    id: paisExterior?.id ?? PAIS_BRASIL.id,
    nome: paisExterior?.nome ?? PAIS_BRASIL.nome,
  },
  municipioResidenciaExterior: localidadeExterior,
})

export const convertToSituacaoRuaFormModel = (situacaoDeRua: SituacaoDeRua): SituacaoRuaFormModel => {
  return (
    situacaoDeRua && {
      grauParentescoVisitaFamiliar: situacaoDeRua.grauParentescoVisitaFamiliar,
      higienePessoal: situacaoDeRua.higienePessoal,
      possuiAcessoHigienePessoal: booleanToSimNaoEnum(situacaoDeRua.stAcessoHigienePessoal),
      instituicaoAcompanhamento: situacaoDeRua.instituicaoAcompanhamento,
      origemAlimentacao: situacaoDeRua.origemAlimentacao,
      quantidadeAlimentacaoDiaria: situacaoDeRua.quantidadeAlimentacaoDiaria,
      possuiReferenciaFamiliar: booleanToSimNaoEnum(situacaoDeRua.possuiReferenciaFamiliar),
      recebeAlgumBeneficio: booleanToSimNaoEnum(situacaoDeRua.recebeAlgumBeneficio),
      stAcompanhadoOutraInstituicao: booleanToSimNaoEnum(situacaoDeRua.stAcompanhadoOutraInstituicao),
      tempoSituacaoRua: situacaoDeRua.tempoSituacaoDeRua,
      visitaFamiliarComFrequencia: booleanToSimNaoEnum(situacaoDeRua.stVisitaFamiliarComFrequencia),
    }
  )
}

export const convertSituacaoFormModelToInput = (model: SituacaoRuaFormModel): SituacaoDeRuaInput => {
  return (
    model && {
      grauParentescoVisitaFamiliar: model.grauParentescoVisitaFamiliar,
      higienePessoal: model.higienePessoal,
      instituicaoAcompanhamento: model.instituicaoAcompanhamento,
      origemAlimentacao: model.origemAlimentacao,
      quantidadeAlimentacaoDiaria: model.quantidadeAlimentacaoDiaria,
      tempoSituacaoDeRua: model.tempoSituacaoRua,
      possuiReferenciaFamiliar: simNaoEnumToBoolean[model.possuiReferenciaFamiliar],
      recebeAlgumBeneficio: simNaoEnumToBoolean[model.recebeAlgumBeneficio],
      stAcessoHigienePessoal: simNaoEnumToBoolean[model.possuiAcessoHigienePessoal],
      stAcompanhadoOutraInstituicao: simNaoEnumToBoolean[model.stAcompanhadoOutraInstituicao],
      stVisitaFamiliarComFrequencia: simNaoEnumToBoolean[model.visitaFamiliarComFrequencia],
    }
  )
}
